import * as RAPIER from '@dimforge/rapier3d-compat'
import * as THREE from 'three'
import { Component } from '../../ecs/Component'
import { Collider } from './Collider'

export class RigidBody extends Component {
    static movementPrediction = true

    body!: RAPIER.RigidBody
    teleporting = false
    buildData: any
    setup(data: any) {
        this.buildData = data
    }
    start(): void {
        const data = this.buildData
        let desc: RAPIER.RigidBodyDesc = data.rigidBodyDesc
        if (desc === undefined) {
            desc = RAPIER.RigidBodyDesc.dynamic()
        }
        desc.setTranslation(this.transform.position.x, this.transform.position.y, this.transform.position.z)
        const rotation = new THREE.Quaternion().setFromEuler(this.transform.rotation)
        desc.setRotation(new RAPIER.Quaternion(rotation.x, rotation.y, rotation.z, rotation.w))
        this.body = this.scene.physicsWorld.createRigidBody(desc)
        this.body.userData = { gameObject: this.gameObject, component: this }

        // rebuild collision
        this.gameObject.getComponent(Collider)?.rebuild()
    }
    teleport(position: THREE.Vector3, rotation: THREE.Euler) {
        this.body.setTranslation(position, true)
        if (position !== undefined) {
            this.transform.setPosition(position.x, position.y, position.z)
            this.body.setTranslation(position, true)
        }
        if (rotation !== undefined) {
            this.transform.setRotationFromEuler(rotation)
            this.body.setRotation(new THREE.Quaternion().setFromEuler(rotation), true)
        }
        this.teleporting = true
        this.update(0)
    }
    onMove(): void {
        if (this.body.bodyType() === RAPIER.RigidBodyType.Fixed) this.teleport(this.transform.position, this.transform.rotation)
    }
    update(_dt: number): void {
        const position = this.body.translation()

        const rotation = this.body.rotation()
        //this.transform.setPosition(position.x, position.y, position.z)
        //this.transform.setRotationFromEuler(new THREE.Euler().setFromQuaternion(new THREE.Quaternion(rotation.x, rotation.y, rotation.z, rotation.w)))

        //Make a smooth transition using lerp, _dt and time.fixedDelta
        let passedTime = this.engine.time.accumulator// + _dt
        if (this.engine.time.accumulator === 0) passedTime = 0
        let factor = _dt / (this.engine.time.fixedDelta - passedTime)
        if (this.teleporting || !RigidBody.movementPrediction) factor = 1
        //clamp factor
        if (factor > 1) factor = 1
        if (factor < 0) factor = 0
        this.transform.position.lerp(new THREE.Vector3(position.x, position.y, position.z), factor)
        const currentRotation = new THREE.Quaternion().setFromEuler(this.transform.rotation)
        currentRotation.slerp(new THREE.Quaternion(rotation.x, rotation.y, rotation.z, rotation.w), factor)
        this.transform.rotation.setFromQuaternion(currentRotation)
        this.transform.markDirty()
        this.teleporting = false
    }
    onDestroy(): void {
        this.scene.physicsWorld.removeRigidBody(this.body)
    }
}